module.exports = __webpack_public_path__ + "img/img-1.48005336.webp";